/**
 * Internal dependencies
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';

/**
 * WordPress dependencies
 */
import { registerBlockType } from '@wordpress/blocks';

const { name, category, attributes } = metadata;

registerBlockType( name, {
	title: 'Blissful Buttons',
	description: 'Boring buttons don’t get clicked',
	keywords: [ 'link', 'button' ],
	icon: 'button',
	example: {
		attributes: {
			className: 'is-style-offset',
			color: 'vivid-green-cyan',
			text: 'Call to Action',
		},
	},
	supports: {
		align: true,
		alignWide: true,
	},
	styles: [
		{ name: 'iyf', label: 'In Your Face', isDefault: true },
		{ name: 'soft', label: 'Soft' },
		{ name: 'offset', label: 'Offset' },
	],
	category,
	attributes,
	edit,
	save,
} );
